import { localize } from "utils/localizer";

const i18n = {
    all: {
        en: "All",
        de: "Alle",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    none: {
        en: "None",
        de: "Keine",
    },
};

export default localize(i18n);
